/**
 * 시간 포맷팅 유틸리티
 */

/**
 * 분을 "시간h 분m" 형식으로 변환
 * @param minutes - 분 단위 시간
 * @returns 포맷팅된 시간 문자열 (예: "2h 30m" 또는 "45m")
 */
export const formatTime = (minutes: number): string => {
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  return hours > 0 ? `${hours}h ${mins}m` : `${mins}m`;
};

/**
 * 상태에 따른 Tailwind CSS 클래스 반환
 * @param status - 사용자 상태
 * @returns Tailwind CSS 클래스 문자열
 */
export const getStatusColor = (status: string): string => {
  switch (status.toLowerCase()) {
    case 'studying':
    case '이용중':
      return 'bg-green-100 text-green-800';
    case 'on_break':
    case '휴식중':
      return 'bg-yellow-100 text-yellow-800';
    case 'completed':
    case '퇴실완료':
      return 'bg-gray-100 text-gray-800';
    default:
      return 'bg-gray-100 text-gray-800';
  }
};

/**
 * 출석 상태에 따른 Tailwind CSS 클래스 반환 (스케줄 기반)
 * @param status - 출석 상태
 * @returns Tailwind CSS 클래스 문자열
 */
export const getAttendanceStatusColor = (status: string): string => {
  switch (status.toLowerCase()) {
    case 'on_time':
    case '출석':
      return 'bg-green-100 text-green-800';  // 초록: 정시 입실
    case 'late':
    case '지각':
      return 'bg-orange-100 text-orange-800';  // 주황: 지각 (유예시간 초과 입실)
    case 'late_grace':
    case '유예중':
      return 'bg-yellow-100 text-yellow-800';  // 노랑: 유예시간 내
    case 'absent':
    case '미출석':
      return 'bg-red-100 text-red-800';  // 빨강: 미출석 (유예시간 초과)
    case 'no_schedule':
    case '스케줄없음':
      return 'bg-gray-100 text-gray-800';  // 회색: 스케줄 없음
    default:
      return 'bg-gray-100 text-gray-800';
  }
};

/**
 * 출석 상태 텍스트를 한글로 변환
 * @param status - 출석 상태
 * @returns 한글 상태 텍스트
 */
export const getAttendanceStatusLabel = (status: string): string => {
  switch (status.toLowerCase()) {
    case 'on_time':
      return '출석';
    case 'late':
      return '지각';
    case 'late_grace':
      return '유예중';
    case 'absent':
      return '미출석';
    case 'no_schedule':
      return '스케줄없음';
    default:
      return status;
  }
};

/**
 * 상태 텍스트를 한글로 변환
 * @param status - 영문 상태
 * @returns 한글 상태 텍스트
 */
export const getStatusLabel = (status: string): string => {
  switch (status.toLowerCase()) {
    case 'studying':
      return '이용중';
    case 'on_break':
      return '휴식중';
    case 'completed':
      return '퇴실완료';
    case 'active':
      return '이용중';
    default:
      return status;
  }
};
